/**
 * 用户申请
 */

 import {
    get,
    post,
    put,
    del
  } from '@/util/request'

  /**
   * 根据Id查询
   * @param {*} Id
   * @returns
   */
  export const SelectUserPermissionById = (Id) => {
    return get('/api/app/UserPermission?CurrentId=' + Id);
  }

  /**
   * 新增数据记录
   * @param {*} data
   * @returns
   */
  export const AddUserPermission = (data) => {
    return post('/api/app/UserPermission', data, {});
  }

  /**
   * 更新数据记录
   * @param {*} data
   * @returns
   */
  export const ModifyUserPermission = (data) => {
    return put('/api/app/UserPermission', data, {});
  }

  /**
   * 编辑申请状态
   * @param {*} data
   * @returns
   */
  export const ModifyStatus = (id,type) => {
    return post('/api/app/UserPermission/'+id+'/ModifyStatus?type='+type, {}, {});
  }

  /**
   * 分页获取
   * @param {*} data
   * @returns
   */
  export const GetDataUserPermissionList = (data) => {
    return post('/api/app/UserPermission/list', data, {});
  }

  /**
   * 链表分页获取
   * @param {*} data
   * @returns
   */
   export const GetDataUserPermissionListByPageQuery = (data) => {
    return post('/api/app/UserPermission/getDataByPageQuery', data, {});
  }

  /**
   * 删除记录
   * @param {*} id
   * @returns
   */
  export const DeleteUserPermission = (id) => {
    return del('/api/app/UserPermission/' + id, {}, {});
  }